import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { VendorAccountInterface, VendorRoleInterface } from '../../services/vendorPortalAccounts'

interface InitialStateType {
  isLoading: boolean
  isShimmerLoading: boolean
  vendorAccounts: VendorAccountInterface[]
  vendorRoles: VendorRoleInterface[]
}

const initialState: InitialStateType = {
  isLoading: false,
  isShimmerLoading: false,
  vendorAccounts: [],
  vendorRoles: [],
}

export const sliceName = 'vendorPortalAccounts'

export const vendorPortalAccountsSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setShimmerLoading: (state, action: PayloadAction<boolean>) => {
      state.isShimmerLoading = action.payload
    },
    setVendorAccounts: (state, action: PayloadAction<VendorAccountInterface[]>) => {
      state.vendorAccounts = action.payload
    },
    setVendorRoles: (state, action: PayloadAction<VendorRoleInterface[]>) => {
      state.vendorRoles = action.payload
    },
  },
})

export const { setLoading, setShimmerLoading, setVendorAccounts, setVendorRoles } =
  vendorPortalAccountsSlice.actions

export default vendorPortalAccountsSlice.reducer
